
module.exports = {
  // TODO: change your profile information here
  name: "Atul Yadav",
  greeting: "Hey 👋",
  greetingDescription: "I'm Atul Yadav and I'm a Software Engineer!",
  githubUrl: "https://github.com/AtulYadav1/Python-Projects.git",
  linkedinUrl: "https://www.linkedin.com/in/atul-yadav-546716194/",
  cvLink: "https://docs.google.com/document/d/1E1234561NMyQA67890ygda7abcdefghijs1jBp7HFI0/",
};
